const REGEX_DIGITS_SPACES_PLUS = /[^0-9\+ ]/gi;
const REGEX_PLUS = /\+/gi;
const REGEX_WIDE_SPACES = /\s{2,}/gi;

export const cleanPhoneNumber = (phoneNumber: string) => {
  // Clean so we only have '+' and digits in the string
  const cleaned = phoneNumber.replace(REGEX_DIGITS_SPACES_PLUS, '').trimStart();
  // Check if it starts with a '+'
  const startsWithPlus = cleaned.startsWith('+');
  // Clean the string so its only digits and single spaces
  const cleanedWithoutPlus = cleaned
    .replace(REGEX_PLUS, '')
    .replace(REGEX_WIDE_SPACES, ' ');
  // Now reinsert the '+' if it started with one
  return `${startsWithPlus ? '+' : ''}${cleanedWithoutPlus}`;
};
